var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGradeD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5H28H44C50.3513 0.5 55.5 5.64873 55.5 12V44C55.5 50.3513 50.3513 55.5 44 55.5H12C5.64873 55.5 0.5 50.3513 0.5 44V12Z",
    fill: "url(#paint0_linear_3315_18422)",
    stroke: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.803 38.5001H19.5842V18.1365H26.8626C28.9109 18.1365 30.6742 18.5441 32.1524 19.3595C33.6306 20.1682 34.7675 21.3316 35.5629 22.8495C36.365 24.3675 36.766 26.1838 36.766 28.2984C36.766 30.4196 36.365 32.2425 35.5629 33.7672C34.7675 35.2918 33.624 36.4618 32.1325 37.2771C30.6477 38.0924 28.8712 38.5001 26.803 38.5001ZM23.8896 34.8112H26.624C27.8967 34.8112 28.9673 34.5858 29.8356 34.1351C30.7106 33.6777 31.3669 32.9717 31.8044 32.0172C32.2485 31.056 32.4706 29.8164 32.4706 28.2984C32.4706 26.7937 32.2485 25.564 31.8044 24.6095C31.3669 23.6549 30.714 22.9523 29.8456 22.5015C28.9772 22.0508 27.9067 21.8254 26.6339 21.8254H23.8896V34.8112Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3315_18422",
    x1: 0,
    y1: 0,
    x2: 56,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175644,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342321,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACACAC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGradeD);
export default __webpack_public_path__ + "static/media/icon-grade-D.196dfcd82a1ced76f9f844b7d2402359.svg";
export { ForwardRef as ReactComponent };